import React from 'react';
import FoodsListFunctional from './components/foods-list-functional';

const FoodsList = () => {
	return <FoodsListFunctional />;
};

export default FoodsList;
